import { AbstractControl, FormGroup, FormArray } from '@angular/forms';

export class ValidationContext {

	protected controll: AbstractControl;
	protected debugg = false;

	constructor(
		protected control: AbstractControl,
		protected debug?: boolean
	) {
		this.controll = control;
		this.debugg = debug;
	}

}
